<div *ngFor = "let key of outputInformationKeys">
	<app-propriety-wrapper [label] = "('main-page.orders.outputInformation.' + key) | translate">
		<p class = "mr-4">{{ outputInformation ? outputInformation[key]: '' | translate }}</p>
	  </app-propriety-wrapper>
	  
</div>


